import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

const supportChatService = {
  checkEnabled: () => api.get('/support-chat/enabled'),

  getMessages: (firmId = null, after = null) => {
    const params = {};
    if (firmId) params.firm_id = firmId;
    if (after) params.after = after;
    return api.get('/support-chat/messages', { params });
  },

  sendMessage: (message, firmId = null) =>
    api.post('/support-chat/messages', { message, firm_id: firmId }),

  sendImageMessage: (file, message = '', firmId = null) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('message', message);
    if (firmId) formData.append('firm_id', firmId);
    return api.post('/support-chat/messages/image', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  sendInternalNote: (message, firmId = null) =>
    api.post('/support-chat/messages/internal-note', { message, firm_id: firmId }),

  markAsRead: (firmId = null) =>
    api.put('/support-chat/read-status', null, {
      params: firmId ? { firm_id: firmId } : {},
    }),

  getUnreadCount: (firmId = null) =>
    api.get('/support-chat/unread-count', {
      params: firmId ? { firm_id: firmId } : {},
    }),

  getFirmChats: () => api.get('/support-chat/firms'),
};

export default supportChatService;
